///<reference path="popoverService.ts"/>
///<reference path="scopeEditorController.ts"/>
module ProcessEditor {
    export function setupPopoverDirective(popoverService: PopoverService, $timeout: ng.ITimeoutService, graphEditDisabled: boolean): ng.IDirective {
        return {
            restrict: "A",
            link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes) => {
                if (graphEditDisabled) {
                    let executionPopoverContent = element.siblings(".frends-execution-data-popover-content");
                    if (executionPopoverContent.length > 0) {
                        popoverService.setupPopover(element, executionPopoverContent, executionPopoverContent.parent(), { onClose() { }, onOpen() { } });
                    }

                } else {

                    var content = element.siblings(".frends-popover-content");

                    var popoverHandler = {
                        onClose() {
                            scope.$broadcast("hide.editor.frends");
                        },
                        onOpen() {
                            scope.$broadcast("show.editor.frends");
                        }
                    };

                    popoverService.setupPopover(element, content, content.parent(), popoverHandler);
                }
            }
        }
    }
    app.directive("frendsSetupPopover", ["PopoverService", "$timeout", "graphEditDisabled", setupPopoverDirective]);

    export function closePopoversOnClickOutsideDirective(popovers: PopoverService): ng.IDirective {
        return {
            restrict: "A",
            link: (scope: IScopeWithNodeController, element: ng.IAugmentedJQuery, attrs: ng.IAttributes) => {
                // dismiss popover on click outside it - original from http://stackoverflow.com/a/19638199
                element.on('click', e => {
                    if (typeof $(e.target).data('original-title') == 'undefined' &&
                        !$(e.target).parentsUntil(".scope-scroll-container").is('.popover.in') &&
                        !$(e.target).parentsUntil(".scope-scroll-container").is('.popover-open')) {
                        let scopeId = scope.ctrl.node && scope.ctrl.node.nodeId;
                        if (!scopeId) {
                            scopeId = "root"; // root by default
                        }
                        popovers.hidePopovers(scopeId);
                    }
                });
            }
        }
    }
    app.directive("frendsClosePopoversOnClickOutside", ["PopoverService", closePopoversOnClickOutsideDirective]);

    export interface IScopeWithNodeController extends ng.IScope {
        ctrl: ScopeEditorController;
    }

    export function taskErrorEditorDirective(popoverService: PopoverService, graphEditDisabled: boolean): ng.IDirective {
        function setupPopover(popoverAnchor: JQuery, scope: ITaskErrorEditorScope, element: ng.IAugmentedJQuery) {

            const popoverContent = element.find(".task-error-handler-content");
            popoverService.setupPopover(popoverAnchor, popoverContent, element, {
                onOpen() {
                    scope.$broadcast("show.graph.frends");
                },
                onClose: () => {
                    // hide all possible popovers within the popover
                    popoverService.hidePopovers(popoverContent);
                    scope.$broadcast("hide.graph.frends");
                },
                additionalClasses: "popover-taskErrorHandler",
                placement: "bottom"
            });

            popoverAnchor.click((e) => {
                popoverService.openPopover(scope.ctrl.node.nodeId, popoverAnchor);
                e.stopPropagation(); // always stop propagation so no extra popovers are triggered
            });
        }

        return {
            restrict: "A",
            templateUrl: "taskErrorEditorDirectiveTemplate.htm",
            scope: {
                ctrl: "=",
                node: "=",
                errorHandler: "="
            },
            link: (scope: ITaskErrorEditorScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes) => {
                scope.graphEditDisabled = graphEditDisabled;
                scope.$watch("errorHandler", (newErrorHandler: ErrorScopeNode) => {
                    const popoverAnchor = element.find(".open-task-error-handler");
                    if (newErrorHandler) {
                        // setup elements
                        setupPopover(popoverAnchor, scope, element);
                    } else {
                        popoverService.disablePopover(popoverAnchor);
                    }
                });
            }
        }
    }
    app.directive("frendsTaskErrorEditor", ["PopoverService", "graphEditDisabled", taskErrorEditorDirective]);

    export interface ITaskErrorEditorScope extends ng.IScope {
        node: Node;
        ctrl: ScopeEditorController;
        errorHandler: ErrorScopeNode;
        graphEditDisabled: boolean;
    }
}